import { Empty, message, Table, Tag } from "antd";
import Search from "antd/lib/input/Search";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllTransferRequests } from "../api/difaOfficialApis";
import { UserContext } from "../App";
import { StyledDiv } from "./styledComponents/styledDiv";

const LIMIT = 100;

export const TransferRequests = () => {
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [playerCount, setPlayerCount] = useState();
  const [currentPage, setCurrentPage] = useState(1);

  const { difaOfficial, documentsConfig } = useContext(UserContext);

  async function loadTransfers() {
    if (!difaOfficial) return;

    const offset = (currentPage - 1) * LIMIT;

    setLoading(true);
    getAllTransferRequests(LIMIT, offset, searchText)
      .then((res) => {
        setPlayerCount(res.data.transfers.count);
        let rows = [];
        res.data.transfers.rows.map((item) => {
          const transfer = {
            registrationNumber: item.playerRegistrationNumber,
            key: item.playerId,
            transferId: item.transferId,
            playerName: item.playerName,
            fromClubId: `${item.fromClubName} | ${item.fromClubId}`,
            toClubId: `${item.toClubName} | ${item.toClubId}`,
            createdAt: new Date(item.createdAt).toLocaleDateString(),
            status: getTransferStatus(item.status),
          };
          return rows.push(transfer);
        });
        setData(rows);
      })
      .catch((err) => {
        message.error("Could not connect with the server. Please try again.");
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const getTransferStatus = (status) => {
    const STATUSES = {
      0: "Pending",
      1: "On Hold",
      2: "Verified",
      3: "Completed",
    };

    const statusColors = {
      Completed: "green",
      Pending: "gray",
      Verified: "blue",
      "On Hold": "red",
    };

    return <Tag color={statusColors[STATUSES[status]]}>{STATUSES[status]}</Tag>;
  };

  const emptyComponent = {
    emptyText: (
      <Empty
        description={
          <span>
            {searchText === ""
              ? "No pending transfer requests."
              : "No results matching your search input."}
          </span>
        }
      />
    ),
  };

  const getIndividualTransferDetails = (id) => {
    navigate(`/transfer-requests/${id}`, { state: id });
  };

  const columns = [
    {
      title: "Transfer ID",
      dataIndex: "transferId",
      width: "10%",
    },
    {
      title: "Player Name",
      dataIndex: "playerName",
      width: "20%",
    },
    {
      title: "From",
      dataIndex: "fromClubId",
      width: "20%",
    },
    {
      title: "To",
      dataIndex: "toClubId",
      width: "20%",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      width: "10%",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "10%",
    },
  ];

  useEffect(() => {
    loadTransfers();
  }, [difaOfficial, currentPage]);

  return (
    <div>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <StyledDiv>
          <Search
            placeholder="Search using Register Number, Name or Email"
            value={searchText}
            onSearch={loadTransfers}
            onChange={(e) => setSearchText(e.target.value)}
            disabled={loading}
            enterButton
          />
        </StyledDiv>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          style={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row ",
              paddingBottom: "10px",
            }}
          >
            <h1
              style={{
                fontSize: "large",
                fontWeight: "bolder",
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              PENDING TRANSFER REQUESTS
            </h1>

            {documentsConfig && documentsConfig.transferOpen === false ? (
              <Tag
                color="grey"
                style={{
                  marginLeft: "15px",
                  marginBottom: "15px",
                }}
              >
                Transfer Window Closed
              </Tag>
            ) : null}
          </div>
          <Table
            columns={columns}
            locale={emptyComponent}
            loading={loading}
            dataSource={data}
            rowKey="transferId"
            pagination={{
              current: currentPage,
              pageSize: LIMIT,
              total: playerCount,
              onChange: (value) => setCurrentPage(value),
            }}
            onRow={(record) => {
              return {
                onClick: () => {
                  getIndividualTransferDetails(record.transferId);
                },
              };
            }}
          />
        </div>
      </div>
    </div>
  );
};
